import { render, staticRenderFns } from "./ModalReservaDeSangue.vue?vue&type=template&id=8bf59066&scoped=true"
import script from "./ModalReservaDeSangue.vue?vue&type=script&lang=ts"
export * from "./ModalReservaDeSangue.vue?vue&type=script&lang=ts"
import style0 from "./ModalReservaDeSangue.vue?vue&type=style&index=0&id=8bf59066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf59066",
  null
  
)

export default component.exports